export default {
    skillCenter: {
        title: '技能中心',
        searchPlaceholder: '搜索技能...',
        createSkill: '创建技能',
        aiCreate: 'AI 创建',
        noSkills: '暂无技能',
        noSkillsDesc: '点击"创建技能"按钮添加您的第一个技能',
        preview: '预览',
        edit: '编辑',
        aiEdit: 'AI 编辑',
        delete: '删除',
        cancel: '取消',
        save: '保存',
        close: '关闭',
        moreActions: '更多操作',
        official: '官方',
        custom: '自定义',
        enabled: '已启用',
        disabled: '已禁用',
        enable: '启用',
        disable: '禁用',
        version: '版本',

        viewModes: {
            grid: '网格视图',
            list: '列表视图',
        },

        pills: {
            official: '官方技能',
            user: '我的技能',
        },

        dialog: {
            createTitle: '创建技能',
            editTitle: '编辑技能',
            previewTitle: '技能详情',
            name: '技能名称',
            namePlaceholder: '请输入技能名称（创建后不可修改）',
            description: '描述',
            descriptionPlaceholder: '请输入描述信息（可选）',
            tags: '标签',
            tagsPlaceholder: '输入后回车添加',
            tagsReadonlyHint: '标签仅创建时可设置',
            editingFile: '正在编辑：{path}',
            binaryFileHint: '二进制文件不支持在线编辑',
            unsavedChangesTitle: '未保存的修改',
            unsavedChangesMessage: '您有未保存的修改，确定要关闭吗？关闭后修改将丢失。',
            discardChanges: '放弃修改',
            continueEditing: '继续编辑',
        },

        workspace: {
            title: 'AI 工作台',
            backToList: '返回技能列表',
            loadingTitle: '加载中…',
            chatUnavailableTitle: 'AI 对话暂不可用',
            chatUnavailableDesc: 'Skill 工作区初始化失败或后端服务未就绪，可稍后从技能列表重新进入。',
            toolResultTitle: '工具结果',
            saving: '保存中…',
        },

        fileTree: {
            newFile: '新建文件',
            fileName: '文件名',
            fileNamePlaceholder: '例如 api.md、run.py（请包含扩展名）',
            fileNameInvalid: '文件名不能包含 /',
            newDirectory: '新建目录',
            directoryName: '目录名称',
            parentPath: '父目录',
            rootPath: '（根目录）',
            rename: '重命名',
            newName: '新名称',
            skillMdProtectedHint: 'SKILL.md 不支持重命名或删除',
        },

        security: {
            violationsTitle: '内容安全审查未通过',
            blockedHint: '请根据以下违规项修改内容后重新保存',
            ruleId: '规则',
        },

        messages: {
            fetchListFailed: '获取技能列表失败',
            fetchDetailFailed: '获取技能详情失败',
            fetchFileFailed: '获取文件内容失败',
            createSuccess: '创建成功',
            createFailed: '创建失败',
            nameExists: '技能名称已存在，请修改后重试',
            updateSuccess: '更新成功',
            updateFailed: '更新失败',
            metadataSavedFilesNotSaved: '技能信息已保存，但部分文件未保存成功，请检查违规内容后重试',
            deleteSuccess: '删除成功',
            deleteFailed: '删除失败',
            enableSuccess: '启用成功',
            enableFailed: '启用失败',
            disableSuccess: '禁用成功',
            disableFailed: '禁用失败',
            permissionDenied: '无权限操作该技能',
            updateFileFailed: '保存文件失败',
            createDirectorySuccess: '目录创建成功',
            createDirectoryFailed: '目录创建失败',
            createFileSuccess: '文件创建成功',
            createFileFailed: '文件创建失败',
            fileExists: '同名文件已存在',
            renameSuccess: '重命名成功',
            renameFailed: '重命名失败',
            deleteFileSuccess: '文件已删除',
            deleteFileFailed: '删除文件失败',
            emptyFolderNotDeletable: '空目录暂不支持删除',
            workspaceInitFailed: 'AI 工作区初始化失败，对话功能暂不可用',
        },
    },
};
